import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import NavBar from "@/components/NavBar";

export default function AdminLoginPage() {
  const [busy, setBusy] = useState(false);

  const signIn = () => {
    setBusy(true);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <>
      <NavBar />
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link to="/" className="text-sm text-gg-muted hover:text-gg-green">← Back home</Link>
        <div className="mt-6 rounded-2xl border border-gg-border bg-gg-surface p-8 fade-up d1">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-gg-green/10 text-gg-green flex items-center justify-center">
              <LogIn size={18} />
            </div>
            <div>
              <h1 className="font-heading text-2xl text-[var(--gg-text)]">Admin sign-in</h1>
              <p className="text-xs text-gg-muted">Graceful Garden Coaching</p>
            </div>
          </div>
          <p className="text-sm text-gg-muted mb-6 leading-relaxed">
            Sign in with the Google account on file —{" "}
            <strong className="text-[var(--gg-text)]">heather@gracefulgardencoaching.com</strong>.
            Only this account has access.
          </p>
          <button
            type="button"
            onClick={signIn}
            disabled={busy}
            className="w-full h-12 rounded-full bg-white border border-gg-border hover:border-gg-green hover:bg-gg-bg flex items-center justify-center gap-3 font-semibold text-[var(--gg-text)] transition-colors disabled:opacity-60"
            data-testid="admin-google-signin-btn"
          >
            <GoogleG />
            {busy ? "Opening Google…" : "Continue with Google"}
          </button>
          <p className="text-xs text-gg-muted text-center mt-4 leading-relaxed">
            By signing in you agree to a 7-day session cookie used only to keep you logged in to the admin.
          </p>
        </div>
      </div>
    </>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.49h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.91c1.71-1.57 2.69-3.89 2.69-6.63z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.95-2.18l-2.9-2.26c-.81.54-1.83.86-3.05.86-2.34 0-4.32-1.58-5.03-3.71H.96v2.33A9 9 0 0 0 9 18z"/>
      <path fill="#FBBC05" d="M3.97 10.71A5.4 5.4 0 0 1 3.68 9c0-.6.1-1.17.29-1.71V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.33z"/>
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.46 3.43 1.34l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.96l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/>
    </svg>
  );
}
